"use client";

import { useAuthState } from "react-firebase-hooks/auth";
import {auth} from "@/lib/firebase";
import {createContext, useContext} from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, loading, error] = useAuthState(auth);

    return (
        <AuthContext.Provider value={{ user, loading, error }}>
            {children}
        </AuthContext.Provider>
    );
};

// Custom hook to use the auth context
export const useAuth = () => useContext(AuthContext);
